<input
  class="period-input"
  #input
  type="text"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  (keydown)="onKeyDown($event)" />
